import { graphql, useFragment } from 'react-relay';
import type { flag_nativeIssueTable_FlagCell$key } from '@atlassian/jira-relay/src/__generated__/flag_nativeIssueTable_FlagCell.graphql';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages.tsx';

export type Props = {
	fieldRef: flag_nativeIssueTable_FlagCell$key;
};

export const FlagCell = ({ fieldRef }: Props) => {
	const data = useFragment<flag_nativeIssueTable_FlagCell$key>(
		graphql`
			fragment flag_nativeIssueTable_FlagCell on JiraFlagField {
				flag {
					isFlagged
				}
			}
		`,
		fieldRef,
	);
	const { formatMessage } = useIntl();

	return data.flag?.isFlagged && formatMessage(messages.flagged);
};
